function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "44.994%",
  x2: "100%",
  y2: "62.111%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEA948",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC25F",
  offset: "69.732%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC78",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "31.571%",
  y1: "58.95%",
  x2: "78.375%",
  y2: "43.384%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8E3901",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6400",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "58.156%",
  y1: "94.462%",
  x2: "100%",
  y2: "5.538%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEA948",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC78",
  offset: "74.26%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC78",
  offset: "100%"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-10.3%",
  y: "-17.6%",
  width: "120.6%",
  height: "135.1%",
  filterUnits: "objectBoundingBox",
  id: "c"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -8,
  dy: 4,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.798622284 0 0 0 0 0.468829792 0 0 0 1 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 15,
  dy: -9,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.996078431 0 0 0 0 0.725490196 0 0 0 0 0.282352941 0 0 0 0.748405403 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-18.1%",
  y: "-19.2%",
  width: "136.2%",
  height: "138.4%",
  filterUnits: "objectBoundingBox",
  id: "h"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -3,
  dy: 9,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.8 0 0 0 0 0.470588235 0 0 0 1 0",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M63 0c34.794 0 63 27.31 63 61 0 3.273-.266 6.486-.779 9.619C110.013 72.692 87.774 74 63 74 38.226 74 15.987 72.692.779 70.618A59.532 59.532 0 0 1 0 61C0 27.31 28.206 0 63 0z",
  id: "a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.83 0C95.51.011 90.738 10.423 90.056 11.626c-1.482 2.614-4.354 4.936-6.547 2.334-1.005-1.193-.112-3.4.669-4.66 1.317-2.13-.437-4.798-2.915-4.466C69.141 6.457 55.265 19.196 58.085 35.44c1.479 8.515 11.739 19.19 28.75 11.186 11.35-5.896 12.841-17.154 15.12-30.337 1.025-5.933 3.749-8.68 6.435-9.909 2.316-1.059 2.383-4.345.048-5.362C106.813.31 105.288.003 103.867 0h-.037z",
  id: "g"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("ellipse", {
  fill: "#96673B",
  cx: 83,
  cy: 92,
  rx: 83,
  ry: 10
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 28)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#b)",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#c)",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 64.5C18 70.167 38.167 73 60.5 73 94 73 120 66.5 126 65c4-1 4.833 1.667 2.5 8l-68 5.5L-2 72l2-7.5z",
  fill: "#BC5A1E",
  opacity: 0.104,
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.887-2.307C78.01-2.302 73.49 2.33 72.844 2.865c-1.403 1.163-4.122 2.196-6.199 1.039-.952-.531-.105-1.512.633-2.074 1.248-.947-.413-2.134-2.759-1.986-11.478.722-24.617 6.39-21.946 13.616 1.4 3.787 11.114 8.537 27.222 4.976 10.746-2.623 11.657-8.373 15.523-12.875.97-2.64 5.63-.797 8.173-1.343 2.193-.47-1.03-5.62-3.24-6.072a21.661 21.661 0 0 0-4.33-.453h-.034z",
  fill: "url(#e)",
  opacity: 0.449,
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.178 64.021c0 1.42-1.148 2.57-2.564 2.57a2.567 2.567 0 0 1-2.564-2.57c0-1.419 1.148-2.57 2.564-2.57a2.566 2.566 0 0 1 2.564 2.57M93.169 64.021c0 1.42-1.148 2.57-2.564 2.57a2.567 2.567 0 0 1-2.564-2.57c0-1.419 1.148-2.57 2.564-2.57a2.566 2.566 0 0 1 2.564 2.57",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.127 68.847c-4.205 0-7.614 3.417-7.614 7.63H85.74c0-4.213-3.408-7.63-7.613-7.63",
  fill: "#AC5F17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.557 81.672a5.19 5.19 0 0 0 5.184-5.195H75.373a5.19 5.19 0 0 0 5.184 5.195",
  fill: "#81481B"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "url(#f)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#h)",
  xlinkHref: "#g"
})));

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 102,
    viewBox: "0 0 166 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.92f2b6be.svg";
export { ForwardRef as ReactComponent };